// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Labels ──────────────────────────────────────────────── */

.ep-label {
  font-family: var(--sms-font-ui, 'Barlow', sans-serif);
  font-size: 0.8125rem;
  font-weight: 600;
  color: #1c2127;
  margin-bottom: 0.25rem;
  display: block;
}

.ep-label-block {
  margin-bottom: 0.5rem;
}

.ep-label-sm {
  font-family: var(--sms-font-ui, 'Barlow', sans-serif);
  font-size: 0.75rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.2rem;
  display: block;
}

.ep-label-hint {
  display: block;
  font-size: 0.7rem;
  color: #9ca3af;
  margin-bottom: 0.3rem;
  font-weight: 400;
  font-style: normal;
}

.ep-optional {
  font-size: 0.68rem;
  font-weight: 400;
  color: #9ca3af;
}

/* ── Field groups ─────────────────────────────────────────── */

.ep-field-group {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}

.ep-field-group .form-group {
  margin-bottom: 0.75rem;
}

@media (max-width: 575px) {
  .ep-field-group .form-group {
    margin-bottom: 1rem;
  }
}

/* ── Errors ──────────────────────────────────────────────── */

.ep-error {
  font-size: 0.75rem;
  color: #dc2626;
  margin-top: 0.3rem;
}

.ep-hint {
  font-size: 0.75rem;
  color: #6b7280;
  margin-top: 0.3rem;
}

/* ── Alert override ──────────────────────────────────────── */

.ep-alert-override {
  font-size: 0.8rem;
  border-radius: 0.35rem;
  margin: 0.75rem 0 0;
  padding: 0.6rem 0.875rem;
}

/* ── Manual address toggle ───────────────────────────────── */

.ep-manual-toggle {
  margin-top: 0.5rem;
}

.ep-manual-toggle .form-check-label {
  font-size: 0.75rem;
  color: #6b7280;
  cursor: pointer;
}

/* ── Section rule ────────────────────────────────────────── */

.ep-section-rule {
  border-color: #e5e7eb;
}

/* ── Nav tabs (mobile-first) ─────────────────────────────── */

.ep-nav-tabs .nav-link {
  font-family: var(--sms-font-ui, 'Barlow', sans-serif);
  font-size: 0.8125rem;
  font-weight: 600;
  padding: 0.55rem 1rem;
  letter-spacing: 0.01em;
}

@media (max-width: 575px) {
  .ep-nav-tabs {
    display: flex;
  }
  .ep-nav-tabs .nav-item {
    flex: 1;
  }
  .ep-nav-tabs .nav-link {
    text-align: center;
    font-size: 0.75rem;
    padding: 0.55rem 0.375rem;
    white-space: nowrap;
  }
}

/* ── Tab card ────────────────────────────────────────────── */

.ep-tab-card {
  padding: 1rem 0 0.5rem;
}

/* ── Tax header row ──────────────────────────────────────── */

.ep-tax-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.875rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f0f0f0;
}

.ep-tax-title {
  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #9ca3af;
}

.ep-irs-link {
  font-size: 0.68rem;
  color: #9ca3af;
  text-decoration: none;
  letter-spacing: 0.01em;
  transition: color 0.1s;
}

.ep-irs-link:hover {
  color: var(--sms-blue, #346498);
}

/* ── Radio group ─────────────────────────────────────────── */

.ep-radio-group {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.ep-radio-item {
  padding-left: 1.75rem;
}

.ep-radio-item .form-check-label {
  font-size: 0.8125rem;
  color: #374151;
  cursor: pointer;
  line-height: 1.45;
}

/* ── LLC / Other sub-inputs ──────────────────────────────── */

.ep-llc-item {
  display: flex;
  flex-direction: column;
}

.ep-llc-class-input {
  padding-left: 0;
  margin-top: 0.5rem;
}

.ep-other-input {
  margin-top: 0.4rem;
  max-width: 22rem;
}

/* ── Exemptions column ───────────────────────────────────── */

.ep-exemptions-col {
  padding-top: 1rem;
  border-top: 1px dashed #e5e7eb;
  margin-top: 0.25rem;
}

@media (min-width: 768px) {
  .ep-exemptions-col {
    padding-top: 0.875rem;
    border-top: none;
    border-left: 1px dashed #e5e7eb;
    margin-top: 0;
  }
}

/* ── Legal text — subordinate boilerplate ────────────────── */

.ep-legal-text {
  font-size: 0.72rem;
  color: #b0b7c3;
  line-height: 1.6;
  margin-bottom: 0.4rem;
}

.ep-legal-text p,
.ep-legal-text li {
  font-size: 0.72rem;
  color: #b0b7c3;
  line-height: 1.6;
}

.ep-legal-text li {
  margin-bottom: 0.35rem;
}

/* ── Collapsible legal detail ────────────────────────────── */

.ep-legal-details {
  margin-top: 0.6rem;
}

.ep-legal-details > summary {
  font-size: 0.7rem;
  font-weight: 600;
  color: #b0b7c3;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  list-style: none;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  letter-spacing: 0.01em;
  transition: color 0.1s;
}

.ep-legal-details > summary::-webkit-details-marker {
  display: none;
}

.ep-legal-details > summary::before {
  content: '▸';
  font-size: 0.6rem;
  display: inline-block;
  transition: transform 0.15s ease;
}

.ep-legal-details[open] > summary::before {
  transform: rotate(90deg);
}

.ep-legal-details > summary:hover {
  color: #6b7280;
}

/* ── Non-resident certification checkbox ─────────────────── */

.ep-resident-cert {
  padding: 0.5rem 0;
}

.ep-resident-cert .form-check-label {
  font-size: 0.8125rem;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
}

/* ── Treaty fields (inside details) ─────────────────────── */

.ep-treaty-fields {
  padding-top: 0.5rem;
}

/* ── Certification section ───────────────────────────────── */

.ep-cert-section {
  margin-top: 1.25rem;
  padding: 1rem 0 0.5rem;
  border-top: 1px solid #e5e7eb;
}

.ep-cert-header {
  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: #9ca3af;
  padding-bottom: 0.4rem;
  margin-bottom: 0.75rem;
  border-bottom: 1px solid #f0f0f0;
}

.ep-cert-subhead {
  font-size: 0.8rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/edit-payee/edit-payee.component.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D;EACE,qDAAqD;EACrD,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gEAAgE;;AAEhE;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA,+DAA+D;;AAE/D;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,+DAA+D;;AAE/D;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,+DAA+D;;AAE/D;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,+DAA+D;;AAE/D;EACE,qBAAqB;AACvB;;AAEA,+DAA+D;;AAE/D;EACE,qDAAqD;EACrD,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,OAAO;EACT;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;EACrB;AACF;;AAEA,+DAA+D;;AAE/D;EACE,sBAAsB;AACxB;;AAEA,+DAA+D;;AAE/D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,oEAAoE;EACpE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,+DAA+D;;AAE/D;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,+DAA+D;;AAE/D;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,+DAA+D;;AAE/D;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE;IACE,qBAAqB;IACrB,gBAAgB;IAChB,+BAA+B;IAC/B,aAAa;EACf;AACF;;AAEA,+DAA+D;;AAE/D;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,+DAA+D;;AAE/D;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA,+DAA+D;;AAE/D;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,8DAA8D;;AAE9D;EACE,mBAAmB;AACrB;;AAEA,+DAA+D;;AAE/D;EACE,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,oEAAoE;EACpE,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB","sourcesContent":["/* ── Labels ──────────────────────────────────────────────── */\n\n.ep-label {\n  font-family: var(--sms-font-ui, 'Barlow', sans-serif);\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: #1c2127;\n  margin-bottom: 0.25rem;\n  display: block;\n}\n\n.ep-label-block {\n  margin-bottom: 0.5rem;\n}\n\n.ep-label-sm {\n  font-family: var(--sms-font-ui, 'Barlow', sans-serif);\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 0.2rem;\n  display: block;\n}\n\n.ep-label-hint {\n  display: block;\n  font-size: 0.7rem;\n  color: #9ca3af;\n  margin-bottom: 0.3rem;\n  font-weight: 400;\n  font-style: normal;\n}\n\n.ep-optional {\n  font-size: 0.68rem;\n  font-weight: 400;\n  color: #9ca3af;\n}\n\n/* ── Field groups ─────────────────────────────────────────── */\n\n.ep-field-group {\n  padding-top: 0.875rem;\n  padding-bottom: 0.875rem;\n}\n\n.ep-field-group .form-group {\n  margin-bottom: 0.75rem;\n}\n\n@media (max-width: 575px) {\n  .ep-field-group .form-group {\n    margin-bottom: 1rem;\n  }\n}\n\n/* ── Errors ──────────────────────────────────────────────── */\n\n.ep-error {\n  font-size: 0.75rem;\n  color: #dc2626;\n  margin-top: 0.3rem;\n}\n\n.ep-hint {\n  font-size: 0.75rem;\n  color: #6b7280;\n  margin-top: 0.3rem;\n}\n\n/* ── Alert override ──────────────────────────────────────── */\n\n.ep-alert-override {\n  font-size: 0.8rem;\n  border-radius: 0.35rem;\n  margin: 0.75rem 0 0;\n  padding: 0.6rem 0.875rem;\n}\n\n/* ── Manual address toggle ───────────────────────────────── */\n\n.ep-manual-toggle {\n  margin-top: 0.5rem;\n}\n\n.ep-manual-toggle .form-check-label {\n  font-size: 0.75rem;\n  color: #6b7280;\n  cursor: pointer;\n}\n\n/* ── Section rule ────────────────────────────────────────── */\n\n.ep-section-rule {\n  border-color: #e5e7eb;\n}\n\n/* ── Nav tabs (mobile-first) ─────────────────────────────── */\n\n.ep-nav-tabs .nav-link {\n  font-family: var(--sms-font-ui, 'Barlow', sans-serif);\n  font-size: 0.8125rem;\n  font-weight: 600;\n  padding: 0.55rem 1rem;\n  letter-spacing: 0.01em;\n}\n\n@media (max-width: 575px) {\n  .ep-nav-tabs {\n    display: flex;\n  }\n  .ep-nav-tabs .nav-item {\n    flex: 1;\n  }\n  .ep-nav-tabs .nav-link {\n    text-align: center;\n    font-size: 0.75rem;\n    padding: 0.55rem 0.375rem;\n    white-space: nowrap;\n  }\n}\n\n/* ── Tab card ────────────────────────────────────────────── */\n\n.ep-tab-card {\n  padding: 1rem 0 0.5rem;\n}\n\n/* ── Tax header row ──────────────────────────────────────── */\n\n.ep-tax-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.875rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.ep-tax-title {\n  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #9ca3af;\n}\n\n.ep-irs-link {\n  font-size: 0.68rem;\n  color: #9ca3af;\n  text-decoration: none;\n  letter-spacing: 0.01em;\n  transition: color 0.1s;\n}\n\n.ep-irs-link:hover {\n  color: var(--sms-blue, #346498);\n}\n\n/* ── Radio group ─────────────────────────────────────────── */\n\n.ep-radio-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n.ep-radio-item {\n  padding-left: 1.75rem;\n}\n\n.ep-radio-item .form-check-label {\n  font-size: 0.8125rem;\n  color: #374151;\n  cursor: pointer;\n  line-height: 1.45;\n}\n\n/* ── LLC / Other sub-inputs ──────────────────────────────── */\n\n.ep-llc-item {\n  display: flex;\n  flex-direction: column;\n}\n\n.ep-llc-class-input {\n  padding-left: 0;\n  margin-top: 0.5rem;\n}\n\n.ep-other-input {\n  margin-top: 0.4rem;\n  max-width: 22rem;\n}\n\n/* ── Exemptions column ───────────────────────────────────── */\n\n.ep-exemptions-col {\n  padding-top: 1rem;\n  border-top: 1px dashed #e5e7eb;\n  margin-top: 0.25rem;\n}\n\n@media (min-width: 768px) {\n  .ep-exemptions-col {\n    padding-top: 0.875rem;\n    border-top: none;\n    border-left: 1px dashed #e5e7eb;\n    margin-top: 0;\n  }\n}\n\n/* ── Legal text — subordinate boilerplate ────────────────── */\n\n.ep-legal-text {\n  font-size: 0.72rem;\n  color: #b0b7c3;\n  line-height: 1.6;\n  margin-bottom: 0.4rem;\n}\n\n.ep-legal-text p,\n.ep-legal-text li {\n  font-size: 0.72rem;\n  color: #b0b7c3;\n  line-height: 1.6;\n}\n\n.ep-legal-text li {\n  margin-bottom: 0.35rem;\n}\n\n/* ── Collapsible legal detail ────────────────────────────── */\n\n.ep-legal-details {\n  margin-top: 0.6rem;\n}\n\n.ep-legal-details > summary {\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: #b0b7c3;\n  cursor: pointer;\n  user-select: none;\n  list-style: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  letter-spacing: 0.01em;\n  transition: color 0.1s;\n}\n\n.ep-legal-details > summary::-webkit-details-marker {\n  display: none;\n}\n\n.ep-legal-details > summary::before {\n  content: '▸';\n  font-size: 0.6rem;\n  display: inline-block;\n  transition: transform 0.15s ease;\n}\n\n.ep-legal-details[open] > summary::before {\n  transform: rotate(90deg);\n}\n\n.ep-legal-details > summary:hover {\n  color: #6b7280;\n}\n\n/* ── Non-resident certification checkbox ─────────────────── */\n\n.ep-resident-cert {\n  padding: 0.5rem 0;\n}\n\n.ep-resident-cert .form-check-label {\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: #374151;\n  cursor: pointer;\n}\n\n/* ── Treaty fields (inside details) ─────────────────────── */\n\n.ep-treaty-fields {\n  padding-top: 0.5rem;\n}\n\n/* ── Certification section ───────────────────────────────── */\n\n.ep-cert-section {\n  margin-top: 1.25rem;\n  padding: 1rem 0 0.5rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.ep-cert-header {\n  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);\n  font-size: 0.6875rem;\n  font-weight: 700;\n  letter-spacing: 0.09em;\n  text-transform: uppercase;\n  color: #9ca3af;\n  padding-bottom: 0.4rem;\n  margin-bottom: 0.75rem;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.ep-cert-subhead {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
